import React from "react";
import styles from "./styles.module.css";
import RightArrow from "../../images/RightArrow";

const CTAButton = ({ className = "", titleClass, subtitleClass, iconClass, arrowClass}) => {
    function handleCTA() {

        const url = 'https://shopee.vn/%C4%90%E1%BB%93ng-H%E1%BB%93-%C4%90eo-Tay-Th%E1%BB%9Di-Trang-M%E1%BA%B7t-S%E1%BB%91-%E1%BA%A2-R%E1%BA%ADp-D%C3%A0nh-Cho-N%E1%BB%AF-i.74804504.15895192129'
        window.open(url, '_blank')
    }

    return (
        <button className={`${styles.cta_button} ${className}`} onClick={handleCTA}>
            <div>
                <img src={require('./shopee_icon.png')} className={!iconClass ? styles.shopee : iconClass} />
                <div style={{gap: 0}}>
                    <span className={titleClass} style={{color: '#fff'}}>
                        Mua ngay tại Shopee
                    </span>
                    {/* <span className={subtitleClass}>6,000,000 VND<span style={{ color: '#DDFF00' }}> (14%) </span></span> */}
                </div>
                <img src={require('./arrow.png')} className={!arrowClass ? styles.arrow : arrowClass} />
            </div>
        </button>
    )
}

export default CTAButton